module.exports = __webpack_public_path__ + "img/sr.07e91c15.svg";